import {NewviewOaBaseApi} from "./NewviewOaBaseApi";
import {Methods} from "@newview/infrastructure";


export class ProjectTestQuestionNewV3Api extends NewviewOaBaseApi {

    public get ControllerName(): any {
        return 'project-test-question-new-v3'
    }
    public saveRemark(params){
        return this.send(params,"saveRemark",Methods.POST)
    }


    public getEntityById(id){
        return this.send({id:id},"getEntityById",Methods.GET)
    }

    async getChiefEngineerMess() {
        return this.send({},"getChiefEngineerMess",Methods.GET)
    }
}